import CancelDialogIcon from "@entrilia/shared/icons/CancelDialogIcon";
import type { WorkflowActivity } from "../../../../../../api/types/workflowTypes";
import InfoDialog from "../../../../../common/InfoDialog";
import ActivityChangeSetCreationDialog from "./ActivityChangeSetCreationDialog";
import ChangeSetEditDialog from "./ChangeSetEditDialog";
import TransactionEditDialog from "./TransactionEditDialog";

interface Props {
  workflowId: string;
  activity: WorkflowActivity;
  isMainChangeSetSelected: boolean;
  onClose: () => void;
  onSaved: (updatedActivity: WorkflowActivity) => void;
}

const ActivityEditDialog = ({ workflowId, activity, isMainChangeSetSelected, onClose, onSaved }: Props) => {
  if (!activity.workflowActivityId) {
    return null;
  }

  if (activity.userEditConfiguration?.predefinedFormType === "Transaction" && activity.previewChangeSet) {
    return (
      <TransactionEditDialog
        workflowId={workflowId}
        activityId={activity.workflowActivityId}
        activityChangeSet={activity.previewChangeSet}
        onClose={onClose}
        onSaved={onSaved}
      />
    );
  }

  const isCreateOrUpdateAction =
    isMainChangeSetSelected &&
    (activity.previewChangeSet?.action === "Create" || activity.previewChangeSet?.action === "Update");

  if (
    activity.previewChangeSet &&
    (activity.userEditConfiguration?.predefinedFormType === "ExtractedFields" || isCreateOrUpdateAction)
  ) {
    return (
      <ChangeSetEditDialog
        workflowId={workflowId}
        activityId={activity.workflowActivityId}
        activityChangeSet={activity.previewChangeSet}
        editConfiguration={activity.userEditConfiguration}
        onClose={onClose}
        onSaved={onSaved}
      />
    );
  }

  if (activity.userEditConfiguration?.objectTypeOptions?.length) {
    return (
      <ActivityChangeSetCreationDialog
        workflowId={workflowId}
        activityId={activity.workflowActivityId}
        objectTypeOptions={activity.userEditConfiguration.objectTypeOptions}
        onClose={onClose}
        onSaved={onSaved}
      />
    );
  }

  return (
    <InfoDialog
      onClose={onClose}
      data={{
        title: "Edit Activity",
        description: "This activity cannot be edited.",
        icon: <CancelDialogIcon sx={{ width: 80, height: 80 }} />,
      }}
    />
  );
};

export default ActivityEditDialog;
